import { SxProps, Theme } from "@mui/material";

export const container: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  pb: 2
};

export const topBar: SxProps<Theme> = {
  flexShrink: 0,
  zIndex: 10,
};

export const contentWrapper: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  overflow: "hidden",
  padding: "0px 40px!important",

  "@media (max-width: 700px)": {
    flexDirection: "column",
    padding: "0px!important",
  },
};

export const outletWrapper: SxProps<Theme> = {
  flex: 1,
  p: 3,
  overflowY: "auto"
};
